module.exports = __webpack_public_path__ + "static/media/xtz.8c981a79.svg";